import * as S from "./TermText.style";

interface TermTextProps {
  children: React.ReactElement;
}

export const TermText = ({ children }: TermTextProps) => {
  return <S.TermText>{children}</S.TermText>;
};
